(function(window, angular, undefined) {
    angular.module('formApp')
        .directive('sbDateSelect', [function () {
        
            var template = [
              '<div class="sb-date-select">',
                '<div class="col s4 select-arrows">',
                    '<label for="{{ selectId }}relday" class="hide">Day</label>',
                    '<select id="{{ selectId }}relday" name="{{ selectId }}Day" ng-blur="setTouched()" ng-model="date" aria-labelledby="{{ selectId }}Title {{ selectId }}Error{{ tooltip }}" ng-options="d for d in dates track by d">',
                    '<option value disabled selected>Day</option>',
                    '</select>',
                '</div>',
                '<div class="col s4 select-arrows">',
                    '<label for="{{ selectId }}relmonth" class="hide">Month</label>',
                    '<select id="{{ selectId }}relmonth" name="{{ selectId }}Month" ng-blur="setTouched()" ng-model="month" aria-labelledby="{{ selectId }}Title {{ selectId }}Error{{ tooltip }}" ng-options="m.value as m.name for m in months">',
                    '<option value disabled>Month</option>',
                    '</select>',
                '</div>',
                '<div class="col s4 select-arrows">',
                    '<label for="{{ selectId }}relyear" class="hide">Year</label>',
                    '<select id="{{ selectId }}relyear" name="{{ selectId }}Year" ng-blur="setTouched()" ng-model="year" aria-labelledby="{{ selectId }}Title {{ selectId }}Error{{ tooltip }}" ng-options="y for y in years">',
                    '<option value disabled selected>Year</option>',
                    '</select>',
                '</div>',
              '</div>'
            ];
        
            return {
              restrict: 'A',
              replace: true,
              template: template.join(''),
              require: 'ngModel',
              scope: {
                dateInfo: '@sbDateInfo',
                tooltip:  '@sbTooltip',
                selectId: '@sbSelectId',
                min:      '@min',
                max:      '@max',
                anzValidateConstraints: '=',
                coverdateData: '='
              },
        
              link: function(scope, elem, attrs, model) {
                var min, max;
                
                scope.$watchCollection('[min, max]', function(vals) {
                  min = moment(vals[0] || '1900-01-01');
                  max = moment(vals[1]); // Defaults to now
        
                  updateDateOptions();
                  updateMonthOptions();
                  updateYearOptions();
                });
        
                
                scope.$watch('year', function () {
                  updateMonthOptions();
                });
                scope.$watch('coverdateData', function () {
                  //updateMonthOptions();
                 // console.log("coverdateData changed jjk",scope.coverdateData)
                });
                scope.$watchCollection('[month, year]', function () {
                  updateDateOptions();
                });
        
                scope.$watchCollection('[date, month, year]', function () {
                  if (scope.year && scope.month && scope.date) {
                    var m = moment([scope.year, scope.month-1, scope.date]);
                    model.$setViewValue(m.format('YYYY-MM-DD'));
                  }
                  else {
                    model.$setViewValue();
                  }
                });

                scope.setTouched = function() {
                  model.$setTouched();
                };
        
                function updateYearOptions() {
                  scope.years = [];
        
                  for (var i=max.year(); i>=min.year(); i--) {
                    scope.years.push(i);
                  }
                }
        
                function updateMonthOptions () {
                  // Values begin at 1 to permit easier boolean testing
                  scope.months = [];
        
                  var minMonth = scope.year && min.isSame([scope.year], 'year') ? min.month() : 0;
                  var maxMonth = scope.year && max.isSame([scope.year], 'year') ? max.month() : 11;
        
                  var monthNames = moment.months();
        
                  for (var j=minMonth; j<=maxMonth; j++) {
                    scope.months.push({
                      name: monthNames[j],
                      value: j+1
                    });
                  }
        
                  if (scope.month-1 > maxMonth || scope.month-1 < minMonth) {
                    delete scope.month;
                  }
                }
        
                function updateDateOptions (year, month) {
                  var minDate, maxDate;
        
                  if (scope.year && scope.month && min.isSame([scope.year, scope.month-1], 'month')) {
                    minDate = min.date();
                  } else {
                    minDate = 1;
                  }
        
                  if (scope.year && scope.month && max.isSame([scope.year, scope.month-1], 'month')) {
                    maxDate = max.date();
                  } else if (scope.year && scope.month) { 
                    maxDate = moment([scope.year, scope.month-1]).daysInMonth();
                  } else {
                    maxDate = 31;
                  }
        
                  scope.dates = [];
        
                  for (var i=minDate; i<=maxDate; i++) {
                    scope.dates.push(i);
                  }
                  if (scope.date < minDate || scope.date > maxDate) {
                    delete scope.date;
                  }
                }

                if (scope.anzValidateConstraints) {
                  scope.anzValidateConstraints.forEach(function(constraint) {
                      if (constraint.type === "custom") {
                          if (constraint.name === "mustBeWithin30Days") {
                              model.$validators.mustBeWithin30Days = function(modelValue) {
                                  return model.$isEmpty(modelValue) || moment(modelValue).startOf('day').diff(moment().startOf('day'), 'days') < 30;
                              };
                          }
                          if (constraint.name === "mustBeAtLeastSixWeeksAtTimeOfCover") {
                              model.$validators.mustBeAtLeastSixWeeksAtTimeOfCover = function(modelValue) {
                                  var coverStartDate = moment(scope.coverdateData);
                                  var petDob = moment(modelValue);
                                  return model.$isEmpty(modelValue) || coverStartDate.startOf('day').diff(petDob.startOf('day'),'weeks') >= 6;  // older than 5 full weeks = at least 6 weeks old
                              };
                              registerCoverDateWatch();
                          }
                          if (constraint.name === "cannotBeOlderThan") {
                              var unit = constraint.unit === 'yrs' ? 'years' : constraint.unit;

                              model.$validators.cannotBeOlderThan = function(modelValue) {
                                  var coverStartDate = moment(scope.coverdateData).startOf('day');
                                  return model.$isEmpty(modelValue) || coverStartDate.startOf('day').diff(moment(modelValue).startOf('day'), unit, true) < parseInt(constraint.value) + 1;
                              };
                              registerCoverDateWatch();
                          }
                      }
                  });
                }


                function registerCoverDateWatch() {
                  var unregister = scope.$watch('coverdateData', function(newVal, oldVal) {
                      if (newVal === oldVal) {
                          return;
                      }

                      unregister();
                      model.$validate();
                      registerCoverDateWatch();
                  }, true);
                }


                model.$render = function() {
                  if (!model.$viewValue) {
                    return;
                  }
                  
                  var m = moment(model.$viewValue);
        
                  scope.year = m.year();
                  scope.month = m.month() + 1;
                  scope.date = m.date();
                };
              }
            };
          }]);
   
})(window, window.angular);